import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';
import { FormInputEmail, SelectorWithAvatarContainer } from '@/_containers';
import { UserRolesSelect } from '@/_pages/settings/user-roles/shared/components/user-roles-select';
import { TeamMembersAsyncSelect } from '@/_pages/team-members/shared';
import { nameResolver } from '@/_shared';

import type { SystemUserFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
}: {
  form: UseFormReturn<SystemUserFormSchema>;
  isEditable?: boolean;
  isCreate?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="first_name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
            label="First Name"
            {...field}
            disabled
          />
        )}
      />
      <FormField
        control={form.control}
        name="last_name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
            label="Last Name"
            {...field}
            disabled
          />
        )}
      />
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4" label="Name" {...field} disabled />
        )}
      />
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormInputEmail
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
            label="Email"
            {...field}
            disabled
          />
        )}
      />
      <FormField
        control={form.control}
        name="username"
        render={({ field }) => (
          <FormInput formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4" label="Username" {...field} disabled />
        )}
      />
      <FormField
        control={form.control}
        name="user_type"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
            label="User Type"
            {...field}
            disabled
          />
        )}
      />

      <div className="col-span-12 sm:col-span-6 lg:col-span-4">
        <FormField
          control={form.control}
          name="team_member"
          render={({ field: { value, onChange } }) => (
            <SelectorWithAvatarContainer
              disabled={!isEditable}
              src={value?.profile_image?.at(0)?.url || ''}
              label="Team Member"
              name={nameResolver(value?.first_name, value?.last_name)}
              className="lg:flex-row"
            >
              <TeamMembersAsyncSelect
                label="Team Member"
                value={value ?? null}
                onValueChange={onChange}
                disabled={!isEditable}
              />
            </SelectorWithAvatarContainer>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="microsoft_groups"
        render={({ field }) => (
          <FormInput formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4" label="Group" {...field} disabled />
        )}
      />
      <FormField
        control={form.control}
        name="roles"
        render={({ field }) => (
          <UserRolesSelect
            {...field}
            label="Role"
            disabled={!isEditable}
            onValueChange={(role) => {
              field.onChange(role);
            }}
            value={field.value ?? null}
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
          />
        )}
      />
    </>
  );
}
